export default "__VITE_ASSET__LRd4x0MD__"